import { render, staticRenderFns } from "./Ibu.vue?vue&type=template&id=003a357b&scoped=true&lang=html&"
import script from "./Ibu.vue?vue&type=script&lang=js&"
export * from "./Ibu.vue?vue&type=script&lang=js&"
import style0 from "./Ibu.vue?vue&type=style&index=0&id=003a357b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003a357b",
  null
  
)

export default component.exports